import Vue from 'vue';
import Router from 'vue-router';
import HelloWorld from '@/components/HelloWorld';
import Login from '@/components/Login/Login';
import Dashboard from '@/components/Dashboard';
import ListUser from '@/components/User/ListUser'
import AddUpdateUser from '@/components/User/AddUpdateUser'
import GLExport from '@/components/GLExport/glexport';
import EmailManager from '@/components/EmailManager/EmailManager';
import AddUpdateEmailManager from '@/components/EmailManager/AddUpdateEmailManager';
import LocationManager from '@/components/LocationManager/LocationManager';
import AddUpdateLocationManager from '@/components/LocationManager/AddUpdateLocationManager';
import DepartmentManager from '@/components/DepartmentManager/DepartmentManager';
import AddUpdateDepartment from '@/components/DepartmentManager/AddUpdateDepartment';
import Test from '@/components/Test';
import TopFacilityExport from '@/components/TopFacilityExport/TopFacilityExport';
import ListTrainingEmailManager from '@/components/TrainingEmailManager/ListTrainingEmailManager';
import AddUpdateTrainingEmailManager from '@/components/TrainingEmailManager/AddUpdateTrainingEmailManager';
Vue.use(Router);

export default new Router({
	mode: 'history',
  	routes: [
		{
            path: '/',
            name: 'Login',
            component: Login
		},
		{
            path: '/dashboard',
            name: 'Dashboard',
            component: Dashboard
        },
        {
            path: '/list-user',
            name: 'ListUser',
            component: ListUser
        },
        {
            path: '/add-user',
            name: 'AddUser',
            component: AddUpdateUser
        },
        {
            path: '/update-user/:id',
            name: 'UpdateUser',
            component: AddUpdateUser
        },
        {
            path: '/glexport',
            name: 'GLExport',
            component: GLExport
        },
        {
            path: '/email-manager',
            name: 'EmailManager',
            component: EmailManager
        },
        {
            path: '/addupdateemailmanager/:id?',
            name: 'AddUpdateEmailManager',
            component: AddUpdateEmailManager
        },
        {
            path: '/location-manager',
            name: 'LocationManager',
            component: LocationManager
        },
        {
            path: '/addupdatelocationmanager/:id?',
            name: 'AddUpdateLocationManager',
            component: AddUpdateLocationManager
        },
        {
            path: '/department-manager',
            name: 'DepartmentManager',
            component: DepartmentManager
        },
        {
            path: '/addupdatedepartment/:id?',
            name: 'AddUpdateDepartment',
            component: AddUpdateDepartment
        },
        {
            path: '/test',
            name: 'Test',
            component: Test
        },
        {
            path: '/topfacilityexport',
            name: 'TopFacilityExport',
            component: TopFacilityExport
        },
        {
            path: '/training-email-manager',
            name: 'ListTrainingEmailManager',
            component: ListTrainingEmailManager
        },
        {
            path: '/addupdatetrainingemailmanager/:id?',
            name: 'AddUpdateTrainingEmailManager',
            component: AddUpdateTrainingEmailManager
        },
  	]
})



// WEBPACK FOOTER //
// ./src/router/index.js